module.exports = __webpack_public_path__ + "static/media/right_arrow_disable.dab298c7.svg";